import { render, staticRenderFns } from "./SchoolFacialTeacherTable.vue?vue&type=template&id=0d6d5180&scoped=true&"
import script from "./SchoolFacialTeacherTable.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialTeacherTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d5180",
  null
  
)

export default component.exports